import { DataTableService } from 'src/app/shared/data-table/data-table.service';
import { ToastrService } from 'ngx-toastr';
import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CgpConfirmationDialogService } from '../../../../../app/shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { SourceMaintenanceApiService } from '../../../../../modules/api/source-maintenance-api.service';
import { AddSourceModalService } from './add-source/add-source-modal.service';
import { LazyLoadEvent } from 'primeng/api/public_api';
import { ColumnDef, PageOptions } from '../../../../shared/data-table/data-table.interface';
import { filter, finalize } from 'rxjs/operators';
import { DataTableValidators } from 'src/app/shared/data-table/validators';

@Component({
   templateUrl: './source-maintenance-modal.template.html',
   styleUrls: ['../../tprecm.style.scss']
})
export class SourceMaintenanceModalComponent {

   private readonly emailColumnWidth = '16em';
   // Flag to determine if the sources grid changed.
   private _sourcesChanged = false;

   sources = [];
   total = 0;
   selectedSource;
   loading = false;
   searchBarInput: any;
   sourceNameFilter: any;
  

   pageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('sourceName');

   /**
    * Column names and values for the source table.
    * Matches the DTO.
    *
    * @type {any[]}
    * @memberof SpanMaintenanceModalComponent
    */
   columns: ColumnDef[] = [
      {
         field: 'sourceName', name: 'Source Name',
         validators:
            [
               DataTableValidators.maxLength(50, (message: string) => this.toastr.error(message)),
               DataTableValidators.notEqual('ALL SOURCES', false, (message: string) => this.toastr.error(message))
            ]
      },
      {
         field: 'code', name: 'Code', width: '6em',
         validators: DataTableValidators.maxLength(3, (message: string) => this.toastr.error(message))
      },
      {
         field: 'contactEmail', name: 'Design Source Email #1', width: this.emailColumnWidth,
         validators: [
            DataTableValidators.maxLength(100, (message: string) => this.toastr.error(message)),
            DataTableValidators.email((message: string) => this.toastr.error(message))
         ]
      },
      {
         field: 'contactEmail2', name: 'Design Source Email #2', width: this.emailColumnWidth,
         validators: [
            DataTableValidators.maxLength(100, (message: string) => this.toastr.error(message)),
            DataTableValidators.email((message: string) => this.toastr.error(message))
         ]
      },
      {
         field: 'contactEmail3', name: 'Design Source Email #3', width: this.emailColumnWidth,
         validators: [
            DataTableValidators.maxLength(100, (message: string) => this.toastr.error(message)),
            DataTableValidators.email((message: string) => this.toastr.error(message))
         ]
      },
      {
         field: 'contactEmail4', name: 'Design Source Email #4', width: this.emailColumnWidth,
         validators: [
            DataTableValidators.maxLength(100, (message: string) => this.toastr.error(message)),
            DataTableValidators.email((message: string) => this.toastr.error(message))
         ]
      },
      {
         field: 'contactEmail5', name: 'Design Source Email #5', width: this.emailColumnWidth,
         validators: [
            DataTableValidators.maxLength(100, (message: string) => this.toastr.error(message)),
            DataTableValidators.email((message: string) => this.toastr.error(message))
         ]
      },
      {
         field: 'userSourceContactEmail1', name: 'User Source Email #1', width: this.emailColumnWidth,
         validators: [
            DataTableValidators.maxLength(100, (message: string) => this.toastr.error(message)),
            DataTableValidators.email((message: string) => this.toastr.error(message))
         ]
      },
      {
         field: 'userSourceContactEmail2', name: 'User Source Email #2', width: this.emailColumnWidth,
         validators: [
            DataTableValidators.maxLength(100, (message: string) => this.toastr.error(message)),
            DataTableValidators.email((message: string) => this.toastr.error(message))
         ]
      },
      {
         field: 'userSourceContactEmail3', name: 'User Source Email #3', width: this.emailColumnWidth,
         validators: [
            DataTableValidators.maxLength(100, (message: string) => this.toastr.error(message)),
            DataTableValidators.email((message: string) => this.toastr.error(message))
         ]
      },
      {
         field: 'userSourceContactEmail4', name: 'User Source Email #4', width: this.emailColumnWidth,
         validators: [
            DataTableValidators.maxLength(100, (message: string) => this.toastr.error(message)),
            DataTableValidators.email((message: string) => this.toastr.error(message))
         ]
      },
      {
         field: 'userSourceContactEmail5', name: 'User Source Email #5', width: this.emailColumnWidth,
         validators: [
            DataTableValidators.maxLength(100, (message: string) => this.toastr.error(message)),
            DataTableValidators.email((message: string) => this.toastr.error(message))
         ]
      },
      {
         field: 'userSourceContactEmail6', name: 'User Source Email #6', width: this.emailColumnWidth,
         validators: [
            DataTableValidators.maxLength(100, (message: string) => this.toastr.error(message)),
            DataTableValidators.email((message: string) => this.toastr.error(message))
         ]
      },
      {
         field: 'userSourceContactEmail7', name: 'User Source Email #7', width: this.emailColumnWidth,
         validators: [
            DataTableValidators.maxLength(100, (message: string) => this.toastr.error(message)),
            DataTableValidators.email((message: string) => this.toastr.error(message))
         ]
      },
      {
         field: 'sourceName', name: 'Source Name', editable: false, headerHighlight: false, greyedOut: true
      },
      { field: 'inside', name: 'Inside?', type: 'checkbox', width: '6em', tooltip: 'Inside Source' },
      { field: 'outside', name: 'Outside?', type: 'checkbox', width: '6em', tooltip: 'Outside Source' },
      { field: 'cadence', name: 'Cadence?', type: 'checkbox', width: '6em', tooltip: 'Cadence' },
      { field: 'designSource', name: 'Design Source?', type: 'checkbox', width: '6em', tooltip: 'Design Source' },
      { field: 'constSource', name: 'Construction Source?', type: 'checkbox', width: '6em', tooltip: 'Construction Source' },
      { field: 'firstUserSource', name: 'First User Source?', type: 'checkbox', width: '6em', tooltip: 'First User Source' },
      { field: 'userSource', name: 'User Source?', type: 'checkbox', width: '6em', tooltip: 'User Source' },
      { field: 'active', name: 'Active?', type: 'checkbox', width: '6em', tooltip: 'Check box if source is active.' },
   ];

   constructor(
      private readonly dialogRef: MatDialogRef<SourceMaintenanceModalComponent>,
      private readonly sourceMaintenanceApiService: SourceMaintenanceApiService,
      private readonly addSourceModalService: AddSourceModalService,
      private readonly cgpConfirmationDialogService: CgpConfirmationDialogService,
      private readonly toastr: ToastrService,
      private readonly dataTableService: DataTableService
   ) { }

   onLazyLoad(event: LazyLoadEvent) {
      this.selectedSource = null;

      this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.pageOptions.size = event.rows;
      this.pageOptions.sort = event.sortField;
      this.pageOptions.page = event.first / this.pageOptions.size;

      this.loadSources();
   }

   loadSources() {
      this.loading = true;

      this.sourceMaintenanceApiService.getSources(this.sourceNameFilter, this.pageOptions)
         .pipe(finalize(() => this.loading = false))
         .subscribe(
            (response: any) => {
               if (response) {
                  this.total = response.totalCount;
                  this.sources = response.data;
               }
            }
         );
   }

   refreshSources() {
      this.pageOptions.sort = 'sourceName';
      this.pageOptions.order = 'asc';
      this.loadSources();
   }


   onGridSelectionChange(event: any) {
      this.selectedSource = event;
   }

   onAddSourceClick() {
      const dialog = this.addSourceModalService.showModal();

      dialog.afterClosed()
         .pipe(filter(Boolean))
         .subscribe(() => {
            this.pageOptions.sort = 'id';
            this.pageOptions.order = 'desc';
            this.loadSources();
            this._sourcesChanged = true;
         });
   }

   removeHandler(dataItem: any) {
      if (!dataItem) {
         this.toastr.error('Please select a source.');
         return;
      }

      this.cgpConfirmationDialogService.showConfirmationDialog({
         message: 'Are you sure you want to delete this Source?',
         alert: 'danger',
         onYesClick: () => {
            this.sourceMaintenanceApiService.deleteSource(dataItem.id)
               .pipe(finalize(this.loadSources.bind(this)))
               .subscribe(
                  () => this.toastr.success(`Deleted source ${dataItem.sourceName}`)
               );

            this.selectedSource = null;
            this.cgpConfirmationDialogService.closeConfirmationDialog();
         },
         onNoClick: () => this.cgpConfirmationDialogService.closeConfirmationDialog()
      });
   }

   saveHandler(event: any) {
      event.data.sourceName = (event.data.sourceName || '').toUpperCase();

      this.sourceMaintenanceApiService.saveSource(event.data)
         .pipe(finalize(() => {
            this.loadSources();
            this._sourcesChanged = true;
         }))
         .subscribe(
            () => event.editMode = false
         );
   }

   searchBySource(event: any) {
      this.sourceNameFilter = event.value;
      this.refreshSources();
   }

   clearSearch() {
      this.searchBarInput = '';
      this.sourceNameFilter = '';
      this.refreshSources();
   }

   close() {
      this.dialogRef.close({ sourcesChanged: this._sourcesChanged });
   }

}
